export function Logo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <rect width="64" height="64" rx="14" fill="#171A2B" />
      <path d="M8 32c6-10 14-15 24-15s18 5 24 15c-6 10-14 15-24 15S14 42 8 32z" fill="none" stroke="#22B8CF" strokeWidth="3.5" />
      <circle cx="32" cy="32" r="9" fill="#5457E5" />
      <circle cx="35" cy="29" r="3" fill="#fff" />
    </svg>
  );
}
